export function formatKategorieTitle(kategorie) {
    return kategorie
}